import angular from 'angular';
import uiRouter from 'angular-ui-router';
import receiptComponent from './receipt.component';
import paymentItemComponent from './payment-item/payment-item.component';
import ngMessages from 'angular-messages';

let receiptModule = angular.module('receipt', [
    uiRouter,
    ngMessages
])

.config(($stateProvider) => {
    'ngInject';
    $stateProvider
        .state('newReceipt', {
            url: '/receipts/new?quoteId',
            component: 'receipt',
            parent: 'main',
            data: {
                permissions: {
                    only: ['OPERATOR'],
                    redirectTo: 'home'
                }
            },
            resolve: {
                user: (LoginService) => {
                    return LoginService.getCurrent();
                },
                initialQuote: (QuotesService, $stateParams) => {
                    if ($stateParams.quoteId) {
                        return QuotesService.findById($stateParams.quoteId, {
                            include: ['client', 'vehicle', 'holder']
                        });
                    }
                }
            }
        })
        .state('editReceipt', {
            url: '/receipts/:id',
            component: 'receipt',
            parent: 'main',
            data: {
                permissions: {
                    only: ['OPERATOR'],
                    redirectTo: 'home'
                }
            },
            resolve: {
                user: (LoginService) => {
                    return LoginService.getCurrent();
                },
                receipt: (ReceiptsService, $stateParams) => {
                    let clientScope = {
                        include: {
                            relation: 'quotes',
                            scope: {
                                include: [
                                    {
                                        relation: 'receiptQuotes',
                                        scope: {
                                            where: {
                                                receiptId: $stateParams.id
                                            }
                                        }
                                    },
                                    'holder',
                                    'client',
                                    'procedures',
                                    'vehicle'
                                ]
                            }
                        }
                    };
                    return ReceiptsService.findOne({
                        filter: {
                            where: {
                                id: $stateParams.id
                            },
                            include: [
                                {
                                    relation: 'client',
                                    scope: clientScope
                                },
                                'quotes',
                                {
                                    relation: 'paymentItems',
                                    scope: {
                                        include: [{
                                            relation: 'check',
                                            scope: {
                                                deleted: true
                                            }
                                        },{
                                            relation:  'bankTx',
                                            scope: {
                                                deleted: true
                                            }
                                        }, {
                                            relation:  'taxWithholding',
                                            scope: {
                                                deleted: true
                                            }
                                        }],
                                        deleted: true
                                    }
                                },
                                'employee'
                            ],
                            deleted: true
                        }
                    });
                }
            }
        });
})
    .component('receipt', receiptComponent)
    .component('receiptPaymentItem', paymentItemComponent)
    .name;

export default receiptModule;
